export default { // 已下线，评估app的入口已经不用了,
  tabs: [
    // {
    //   name: 'clue',
    //   path: '/clue',
    //   component: () => import('./src/clue.vue'),
    //   meta: {
    //     title: '线索提交',
    //     isMenu: true,
    //     rule: 'clue'
    //   }
    // }
  ]
}
